














import Vue from 'vue';
import PSelectionChild from '../p-selection-parent/p-selection-child.vue';
import PBreadcrumbPath from './p-breadcrumb-path.vue';

type ChildType = InstanceType<typeof PSelectionChild>;
type BreadcrumbStepType = InstanceType<typeof PBreadcrumbPath>;

export default Vue.extend({
  props: {
    value: { type: undefined, default: undefined },
    color: { type: String, default: undefined },
    activeColor: { type: String, default: undefined },
    visitedColor: { type: String, default: undefined },
  },
  data: () => ({
    children: [] as ChildType[],
  }),
  methods: {
    onStepChange(child: ChildType) {
      for (let i = 0; i < this.children.length; i += 1) {
        const visitedBreadcrumbStep = this.children[i].$parent as BreadcrumbStepType;
        const indexOfActive = this.children.indexOf(child);
        visitedBreadcrumbStep.isVisited = i < indexOfActive;
      }
    },
    onRegister(child: ChildType) {
      child.$on('active', (isActive: boolean) => { if (isActive) this.onStepChange(child); });
      const breadcrumbStep = child.$parent as BreadcrumbStepType;
      if (this.color) {
        // TODO: don't mutate prop directly
        breadcrumbStep.color = this.color;
      }
      if (this.activeColor) {
        // TODO: don't mutate prop directly
        breadcrumbStep.activeColor = this.activeColor;
      }
      if (this.visitedColor) {
        // TODO: don't mutate prop directly
        breadcrumbStep.visitedColor = this.visitedColor;
      }
      this.$nextTick(() => {
        if (child.isActive) {
          this.onStepChange(child);
        }
      });
    },
    onInput(value: any) {
      this.$emit('input', value);
    },
  },
});
